/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Allocation_Not_ChangeableInputs */

const en_error_allocation_not_changeable = /** @type {(inputs: Error_Allocation_Not_ChangeableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The allocation of this order cannot be changed like this.`)
};

/**
* | output |
* | --- |
* | "The allocation of this order cannot be changed like this." |
*
* @param {Error_Allocation_Not_ChangeableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_allocation_not_changeable = /** @type {((inputs?: Error_Allocation_Not_ChangeableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Allocation_Not_ChangeableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_allocation_not_changeable(inputs)
});